export default __webpack_public_path__ + "static/media/Client Logos – 06 – Khaos Labs.df16c30b.svg";